export default function ProductsSection() {
  return (
    <section id="products" className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-xs font-semibold uppercase tracking-widest text-gray-400 mb-4">
            // Our Products
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
            Built for iOS. Designed for You.
          </h2>
          <p className="text-gray-500 text-lg mt-4 max-w-xl mx-auto">
            Two powerful applications crafted to deliver security and performance right in your pocket.
          </p>
        </div>

        {/* Product Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* VPN Card */}
          <div className="rounded-3xl overflow-hidden bg-[#0D0D12] text-white">
            <div className="p-8 md:p-10">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-emerald-500/20">
                  <i className="ri-shield-keyhole-line text-emerald-400 text-xl" />
                </div>
                <span className="text-xs font-semibold uppercase tracking-widest text-emerald-400">Security</span>
              </div>
              <h3 className="text-3xl font-bold mb-3">VPN Application</h3>
              <p className="text-white/60 text-base leading-relaxed mb-8">
                Protect your online privacy and secure your internet connection with military-grade encryption. Browse freely and safely on any iOS device, anywhere in the world.
              </p>
              <div className="grid grid-cols-2 gap-4 mb-8">
                {[
                  { icon: "ri-lock-2-line", label: "256-bit Encryption" },
                  { icon: "ri-eye-off-line", label: "Zero-Log Policy" },
                  { icon: "ri-global-line", label: "Global Servers" },
                  { icon: "ri-speed-line", label: "High-Speed Connection" },
                ].map((f) => (
                  <div key={f.label} className="flex items-center gap-2.5">
                    <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-white/10">
                      <i className={`${f.icon} text-emerald-400 text-sm`} />
                    </div>
                    <span className="text-white/70 text-sm">{f.label}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="w-full h-56 md:h-64 overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/b67328763e08b4bed30199aa752e05a0.jpg"
                alt="VPN Application"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Cleaner Card */}
          <div className="rounded-3xl overflow-hidden bg-[#F0F4FF] text-gray-900">
            <div className="p-8 md:p-10">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-sky-500/20">
                  <i className="ri-sparkling-2-line text-sky-500 text-xl" />
                </div>
                <span className="text-xs font-semibold uppercase tracking-widest text-sky-500">Performance</span>
              </div>
              <h3 className="text-3xl font-bold mb-3">Cleaner Application</h3>
              <p className="text-gray-500 text-base leading-relaxed mb-8">
                Reclaim your iPhone&apos;s full potential. Remove junk files, duplicates, and unused cache to speed up your device and free valuable storage space effortlessly.
              </p>
              <div className="grid grid-cols-2 gap-4 mb-8">
                {[
                  { icon: "ri-delete-bin-2-line", label: "Junk File Removal" },
                  { icon: "ri-file-copy-2-line", label: "Duplicate Cleaner" },
                  { icon: "ri-database-2-line", label: "Cache Optimizer" },
                  { icon: "ri-battery-charge-line", label: "Battery Booster" },
                ].map((f) => (
                  <div key={f.label} className="flex items-center gap-2.5">
                    <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-sky-100">
                      <i className={`${f.icon} text-sky-500 text-sm`} />
                    </div>
                    <span className="text-gray-600 text-sm">{f.label}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="w-full h-56 md:h-64 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=iOS%20cleaner%20app%20interface%20on%20iPhone%20showing%20storage%20optimization%20progress%20chart%20light%20clean%20UI%20white%20background%20showing%20free%20space%20percentage%20performance%20boost%20mobile%20app%20minimal%20design&width=800&height=500&seq=cleaner001&orientation=landscape"
                alt="Cleaner Application"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        {/* Platform badge */}
        <div className="mt-12 flex justify-center">
          <div className="inline-flex items-center gap-3 px-6 py-3 rounded-full bg-gray-100 text-gray-600 text-sm font-medium">
            <i className="ri-apple-line text-lg text-gray-700" />
            Exclusively available on the iOS platform
          </div>
        </div>
      </div>
    </section>
  );
}
